import { render, staticRenderFns } from "./DashboardSection.vue?vue&type=template&id=22d939a7&lang=true&"
import script from "./DashboardSection.vue?vue&type=script&lang=js&"
export * from "./DashboardSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports